import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";

@Component({
	selector: "app-surveys",
	standalone: true,
	imports: [RouterOutlet],
	templateUrl: "./surveys.component.html",
	styleUrls: ["./surveys.component.scss"],
})
export class SurveysComponent {}
